import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core'
import {
  DataContextBuilder,
  IDataContext,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderDataToolbarComponent,
  ElderToolbarContentDirective,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderBasicPaneLayoutComponent,
  ElderPaneComponent,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ProductionCode } from '../production-code'
import { ProductionCodeService } from '../production-code.service'
import { Router } from '@angular/router'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatIcon } from '@angular/material/icon'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-production-code-browser',
  templateUrl: './production-code-browser.component.html',
  styleUrls: ['./production-code-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ProductionCodeBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<ProductionCode>
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const productionCodeService = inject(ProductionCodeService)
    this.data = DataContextBuilder.start<ProductionCode>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap()
      .build(productionCodeService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(prodCode: ProductionCode): void {
    this.router.navigate([{ outlets: { side: ['production-codes', prodCode.id] } }], {
      preserveFragment: true,
    })
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['production-codes', 'new'] } }], {
      preserveFragment: true,
    })
  }
}
